// extracted by mini-css-extract-plugin
export default {"header-box":"HeaderBox_header-box__nPwe5","active-border-right":"HeaderBox_active-border-right__lsigB"};